const INTRO_BLOCK_SELECTOR = ".intro-block";
const PENDING_CLASS = "intro-block--pending";
const VISIBLE_CLASS = "intro-block--visible";

export function initIntroBlocks() {
	const blocks = document.querySelectorAll(INTRO_BLOCK_SELECTOR);

	if (!blocks.length) {
		return;
	}

	if (!("IntersectionObserver" in window)) {
		for (const block of blocks) {
			block.classList.add(VISIBLE_CLASS);
		}

		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) {
					continue;
				}

				entry.target.classList.add(VISIBLE_CLASS);
				observer.unobserve(entry.target);
			}
		},
		{
			threshold: 0.2,
		},
	);

	for (const block of blocks) {
		block.classList.add(PENDING_CLASS);
		observer.observe(block);
	}
}
